import styled from 'styled-components';

const Container = styled.div`
  height: 100%;
  position: relative;
`;

const Box = styled.div`
  padding: 20px;
`;
const WizardFooter = styled.div`
  height: 30px;
  background-color: rgb(32, 144, 136);
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-right: 10px;
  color: white !important;
`;

const Img = styled.img`
  width: 8px;
  height: 15px;
  margin-right: 10px;
`;
const Link = styled.button`
  text-decoration: none;
  background: transparent;
  color: #204ff6;
  transition: color 0.5s;
  margin-top: 15px;
  border: none;
  margin-top: 80px;
  margin-bottom: 0;
  outline-style: none;
  position: absolute;
  top: -65px;
  right: 40px;

  &:hover {
    color: #456eff;
    cursor: pointer;
  }
`;

const WizardContent = styled.div`
  height: 90%;
  width: 100%;
  padding: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const ContainerInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: fit-content;
  min-width: 390px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  padding: 24px 24px;
  margin: 0 auto;
`;

const TimelineContainer = styled.div`
  position: relative;
  padding-left: 32px;
  margin: 16px 0;
  width: 100%;
  max-width: 320px;

  &::before {
    content: '';
    position: absolute;
    left: 7px;
    top: 8px;
    bottom: 8px;
    width: 2px;
    background-color: #c4c4c4;
  }
`;

const TimelineItem = styled.div`
  position: relative;
  padding-bottom: 24px;

  &:last-child {
    padding-bottom: 0;
  }
`;

const TimelineDot = styled.div<{ variant: 'done' | 'active' | 'pending'; color?: string }>`
  position: absolute;
  left: -32px;
  top: 2px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 2px solid
    ${({ variant, color }) =>
      variant === 'active'
        ? color || '#868686'
        : variant === 'done'
          ? '#0D860D'
          : '#c4c4c4'};
  background-color: ${({ variant, color }) =>
    variant === 'active'
      ? color || '#868686'
      : variant === 'done'
        ? '#0D860D'
        : 'transparent'};
`;

const TimelineTitle = styled.span<{ color?: string }>`
  font-size: 15px;
  font-weight: 600;
  color: ${({ color }) => color || 'inherit'};
`;

const TimelineDate = styled.span`
  display: block;
  font-size: 12px;
  color: #888;
  margin-top: 2px;
`;

const JustificationBox = styled.div`
  margin-top: 10px;
  background-color: #fdecea;
  border-radius: 6px;
  padding: 10px 14px;
  font-size: 13px;
  color: #611a15;
  line-height: 1.6;
`;

const InfoHeader = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
  margin-bottom: 24px;
  align-self: flex-start;
`;

const InfoRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 6px 0;
  width: 100%;
  max-width: 320px;
`;

export { Container, Box, WizardFooter, Img, WizardContent, Link, ContainerInfo,TimelineContainer, TimelineItem, TimelineDot, JustificationBox, InfoHeader, InfoRow, TimelineTitle, TimelineDate };
